import { createSelector } from "reselect";
import { sectionsSelector } from "../../../sections_selector";

export const woundRiskSectionSelector = createSelector(
  sectionsSelector,
  sections => {
    return sections.woundRisk;
  }
);
